import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, sub, sup, tt, var,
  u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  h1{
    font-size: 32px;
    font-family: "Roboto";
  }

  h2{
    font-size: 30px;
    font-family: "Roboto";
  }

  h3{
    font-size: 1.25em;
    font-family: "Roboto";
  }

  h1, h2{
    font-weight: 700;
    color: black;
  }

  h3, h4 {
    font-family: "Roboto";
  }

  p, div{
    font-family: "Roboto";
    color: #333333;
  }

  p {
    display: block;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  .personText > p {
    font-family: "Roboto",'Open Sans',sans-serif;
    line-height: 1.6;
    font-size: 20px;
  }

  .personButtonAndCaptchaWrapperLargeView {
    width: 50%;
    margin-top: 20px;
    position: relative;
    float: left;
  }

  .personButtonAndCaptchaWrapperMobileView {
    float: left;
    position: relative;
  }

  .personCaptchaWrapper {
    margin-left: 12%;
  }

  .personButtonWrapperLargeView {
    margin-left: 11%;
  }

  .personButtonWrapperMobileView {
    margin-left: 0%;
  }

  .personInputWithStateRegularInput {
    width: 95%;
    min-height: 2.5rem;
    font-family: "Roboto", 'Open Sans', sans-serif;
  }

  .checkboxGroupWrapper {
    margin-bottom: -2em;
    margin-top: -2em;
    font-family: "Roboto", 'Open Sans',sans-serif;
    h3 {
      font-family: "Roboto", 'Open Sans',sans-serif;
    }
  }

  em {
    font-style: italic;
  }

  div, p, h1, h2, h3, h4{
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }


  /* Added to Fix Footer to bottom of viewport */
  html, body {
    height: 100%;
  }
  .siteRoot {
    height: 100vh;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .siteContent {
    flex: 1 0 auto;
  }
  footer {
    width: 100%;
  }

  /* End Fix to Place Footer on Bottom of Viewport */

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  @media screen and (min-width: 35em) {
    html {
      margin-right: calc(-100vw + 100%);
      overflow-x: hidden;
    }
  }

  ol, ul, li {
    list-style: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    box-sizing: border-box;
  }

  body {
    background: white;
    line-height: 1;
    font-size: 100%;
    font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
    font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    @import url('https://fonts.googleapis.com/css?family=Playfair+Display:400,700,900');
    @import url('https://fonts.googleapis.com/css?family=Lora:400,700');
  }

  img {
    display: block;
  	width: 100%;
  	height: auto;
  }
`
